export default __webpack_public_path__ + "static/media/copy-book.ede096d7.svg";